import { Modal } from "react-bootstrap";
import styles from "./TrainerSlotsEditModal.module.scss";
import { FaRegTimesCircle, FaTimesCircle } from "react-icons/fa";
import moment from "moment";
import { useState } from "react";
import {
  checkTimeOverlapping,
  compareTime,
  convert12to24,
} from "../../../../../utils/helpers";
import { trainerAvailableTimeSlots } from "../constants";
import Select from "react-select";
import { toast } from "react-toastify";

const TrainerSlotsEditModal = ({
  slotData,
  onClose,
  onSave,
}: {
  slotData: { [key: string]: any };
  onClose: CallableFunction;
  onSave: CallableFunction;
}) => {
  const selectedTimings =
    slotData?.slots?.map((item: any) => ({
      availableHourStart: {
        value: convert12to24(item?.formattedStartTime),
        label: item?.formattedStartTime,
      },
      availableHourEnd: {
        value: convert12to24(item?.formattedEndTime),
        label: item?.formattedEndTime,
      },
    })) || [];

  const [timings, setTimings] = useState<any>([...selectedTimings]);

  const handleChange = (value: any, index: number, key: string) => {
    const updateArray = timings?.map((item: any, idx: number) => {
      if (index === idx) {
        return {
          ...item,
          [key]: {
            ...value,
          },
        };
      } else {
        return item;
      }
    });
    setTimings([...updateArray]);
  };

  const handleDelete = (indexToDelete: number) => {
    setTimings([
      ...timings?.filter((item: any, idx: number) => idx !== indexToDelete),
    ]);
  };

  const handleAdd = () => {
    setTimings([
      ...timings,
      {
        availableHourStart: {
          value: "",
          label: "",
        },
        availableHourEnd: {
          value: "",
          label: "",
        },
      },
    ]);
  };

  const handleSave = () => {
    const slotTimings = timings?.map((item: any) => ({
      availableHourStart: item?.availableHourStart?.value,
      availableHourEnd: item?.availableHourEnd?.value,
    }));

    if (slotTimings?.length === 0) {
      toast.error("No slot timings given.");
      return;
    }

    const emptyTimings = slotTimings?.some(
      (item: any) => !item?.availableHourStart || !item?.availableHourEnd
    );
    const slotsWithSameStartAndEndTime = slotTimings?.some(
      (item: any) => item?.availableHourStart === item?.availableHourEnd
    );
    const slotsWithSameStartTimeLessThanEndTime = slotTimings?.some(
      (item: any) =>
        compareTime(item?.availableHourEnd, item?.availableHourStart)
    );

    if (emptyTimings) {
      toast.error("Slots timings should not be empty.");
      return;
    }
    if (slotsWithSameStartAndEndTime) {
      toast.error("Start time and end time should not be same.");
      return;
    }
    if (slotsWithSameStartTimeLessThanEndTime) {
      toast.error("Start time should be less than end time.");
      return;
    }
    if (checkTimeOverlapping(slotTimings)) {
      toast.error("There cannot be any overlapping time slots.");
      return;
    }

    onSave(slotData?.date, slotTimings);
  };

  if (!slotData || !slotData?.date || !Array.isArray(slotData?.slots)) {
    return null;
  }

  return (
    <Modal show={true} className={styles.slotEditModal}>
      <Modal.Header>
        <Modal.Title>
          <span className="fs-24 fw-700 text-grey-900">Edit slot</span>
        </Modal.Title>
        <FaRegTimesCircle
          size={28}
          className="cursor-pointer"
          onClick={() => {
            onClose();
          }}
        />
      </Modal.Header>
      <Modal.Body>
        <div className="p-4">
          <div className="row">
            <div className="col-4">
              <span className="fs-18 fw-600">
                {moment(slotData?.date).format("ddd, DD MMM YYYY")}
              </span>
            </div>
            <div className="col-8">
              <div>
                {timings?.map((item: any, index: number) => {
                  return (
                    <div
                      className="row mb-3 align-items-center"
                      key={`slot-${index}`}
                    >
                      <div className="col-5">
                        <Select
                          isMulti={false}
                          value={item?.availableHourStart}
                          onChange={(option: any) => {
                            handleChange(option, index, "availableHourStart");
                          }}
                          className="basic-single"
                          classNamePrefix="select"
                          isClearable={false}
                          isRtl={false}
                          isSearchable={true}
                          name={`availableHourStart-${index}`}
                          options={trainerAvailableTimeSlots}
                        />
                      </div>
                      <div className="col-1 text-center">-</div>
                      <div className="col-5">
                        <Select
                          isMulti={false}
                          onChange={(option: any) => {
                            handleChange(option, index, "availableHourEnd");
                          }}
                          value={item?.availableHourEnd}
                          className="basic-single"
                          classNamePrefix="select"
                          isClearable={false}
                          isRtl={false}
                          isSearchable={true}
                          name={`availableHourEnd-${index}`}
                          options={trainerAvailableTimeSlots}
                        />
                      </div>
                      <div className="col-1 text-danger">
                        <FaTimesCircle
                          className="cursor-pointer"
                          onClick={() => {
                            handleDelete(index);
                          }}
                        />
                      </div>
                    </div>
                  );
                })}
              </div>
              <button
                className="btn btn-sm btn-outline-secondary btn-sm"
                onClick={handleAdd}
              >
                Add new slot
              </button>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="d-block">
        <div className="row py-2">
          <div className="col-6">
            <button
              className="btn btn-outline-secondary w-100 d-block py-2 btn-lg"
              onClick={() => {
                onClose();
              }}
            >
              Cancel
            </button>
          </div>
          <div className="col-6">
            <button
              className="btn btn-success w-100 d-block py-2 btn-lg"
              onClick={handleSave}
            >
              Save
            </button>
          </div>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default TrainerSlotsEditModal;
